import { render, staticRenderFns } from "./Loadout.vue?vue&type=template&id=6b629272&scoped=true&"
import script from "./Loadout.vue?vue&type=script&lang=ts&"
export * from "./Loadout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b629272",
  null
  
)

export default component.exports